import * as React from "react";
import Badge from "components/bootstrap/Badge";
const BADGE_COLOR_BY_SEVERITY = {
  urgent: "danger",
  normal: "info"
};
function SeverityBadge({ severity }) {
  return /* @__PURE__ */ React.createElement(Badge, { bsSize: "sm", bsStyle: BADGE_COLOR_BY_SEVERITY[severity] || "warning" }, severity);
}
export default SeverityBadge;
